"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = require("@lingui/react");

var _react2 = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _blocks = require("@bueno/blocks");

const Overlay = _styledComponents.default.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  position: ${({
  posRel
}) => posRel ? 'relative' : 'absolute'};
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  padding: ${_blocks.spacing.extraLoose};
  font-size: 19px;
  background: ${({
  omitBackground
}) => omitBackground ? 'none' : `rgba(255, 255, 255, ${_blocks.opacity.tint})`};
  z-index: ${_blocks.layer.fixedContent};
  border-radius: 0 0 ${_blocks.borderRadius.large} ${_blocks.borderRadius.large};
`;

const NoResultsOverlay = ({
  noResultsMessage = false,
  selectedSitesMessage = false,
  omitBackground = false,
  posRel = false,
  noActionsMessage = false,
  noInsightsMessage = false
}) => /*#__PURE__*/_react2.default.createElement(Overlay, {
  omitBackground: omitBackground,
  posRel: posRel
}, /*#__PURE__*/_react2.default.createElement(_blocks.DisplaySmall, null, noResultsMessage && /*#__PURE__*/_react2.default.createElement(_react.Trans, {
  id: "no_results_overlay.no_results_message"
}), selectedSitesMessage && /*#__PURE__*/_react2.default.createElement(_react.Trans, {
  id: "no_results_overlay.found_for_selected_sites"
}), noActionsMessage && /*#__PURE__*/_react2.default.createElement(_react.Trans, {
  id: "no_results_overlay.found_for_selected_insight"
}), noInsightsMessage && /*#__PURE__*/_react2.default.createElement(_react.Trans, {
  id: "no_results_overlay.no_insights"
})));

var _default = NoResultsOverlay;
exports.default = _default;
module.exports = exports.default;